// Client-facing strings for the shared preview. Auto-switches to French
// when the customer's device/browser language is French.
export const isFrench = () =>
  (navigator.language || navigator.userLanguage || "en").toLowerCase().startsWith("fr");

const STRINGS = {
  en: {
    approved: "Approved",
    approveDesign: "Approve design",
    commentModeHint: "Click, then tap anywhere on the page to leave a note",
    tapToAdd: "Tap the page to add",
    leaveFeedback: "Leave feedback",
    viewAllFeedback: "View all feedback",
    notes: "Notes",
    desktop: "Desktop",
    mobile: "Mobile",
    pinHint: "Tap anywhere on the page to pin your note",
    previewNotFound: "Preview not found",
    previewInvalid: "This shared link is invalid or has been removed.",
    goTo: (name) => `Go to ${name}`,
    leaveFeedbackHere: "Leave feedback here",
    yourName: "Your name",
    describeChange: "Describe the change you'd like…",
    enterToPost: "⌘+Enter to post",
    cancel: "Cancel",
    postFeedback: "Post feedback",
    writeNoteFirst: "Write a note first",
    commentAdded: "Comment added",
    couldNotAdd: "Could not add comment",
    couldNotUpdate: "Could not update",
    commentRemoved: "Comment removed",
    couldNotDelete: "Could not delete",
    approvedToast: "Design approved — your designer has been notified",
    couldNotApprove: "Could not approve",
    couldNotReply: "Could not send reply",
    feedback: "Feedback",
    noFeedbackA: "No feedback yet. Click",
    noFeedbackB: "then tap anywhere on the preview to pin a note.",
    reopen: "Reopen",
    resolve: "Resolve",
    resolved: "Resolved",
    del: "Delete",
    reply: "Reply",
    writeReply: "Write a reply…",
  },
  fr: {
    approved: "Approuvé",
    approveDesign: "Approuver le design",
    commentModeHint: "Cliquez, puis touchez n'importe où sur la page pour laisser une note",
    tapToAdd: "Touchez la page pour ajouter",
    leaveFeedback: "Laisser un commentaire",
    viewAllFeedback: "Voir tous les commentaires",
    notes: "Notes",
    desktop: "Ordinateur",
    mobile: "Mobile",
    pinHint: "Touchez n'importe où sur la page pour épingler votre note",
    previewNotFound: "Aperçu introuvable",
    previewInvalid: "Ce lien partagé est invalide ou a été supprimé.",
    goTo: (name) => `Aller à ${name}`,
    leaveFeedbackHere: "Laissez un commentaire ici",
    yourName: "Votre nom",
    describeChange: "Décrivez la modification souhaitée…",
    enterToPost: "⌘+Entrée pour publier",
    cancel: "Annuler",
    postFeedback: "Publier",
    writeNoteFirst: "Écrivez d'abord une note",
    commentAdded: "Commentaire ajouté",
    couldNotAdd: "Impossible d'ajouter le commentaire",
    couldNotUpdate: "Mise à jour impossible",
    commentRemoved: "Commentaire supprimé",
    couldNotDelete: "Suppression impossible",
    approvedToast: "Design approuvé — votre concepteur a été notifié",
    couldNotApprove: "Approbation impossible",
    couldNotReply: "Impossible d'envoyer la réponse",
    feedback: "Commentaires",
    noFeedbackA: "Aucun commentaire pour l'instant. Cliquez sur",
    noFeedbackB: "puis touchez l'aperçu pour épingler une note.",
    reopen: "Rouvrir",
    resolve: "Résoudre",
    resolved: "Résolu",
    del: "Supprimer",
    reply: "Répondre",
    writeReply: "Écrivez une réponse…",
  },
};

export const getStrings = () => STRINGS[isFrench() ? "fr" : "en"];
